webpackJsonp([220279231315142],{

/***/ 1441:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"Filter","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"cmp","type":{"kind":"ENUM","name":"Comparison","ofType":null}},{"defaultValue":null,"description":null,"name":"field","type":{"kind":"ENUM","name":"FilterField","ofType":null}},{"defaultValue":null,"description":null,"name":"value","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-filter-be5d247d274e6b9a52ac.js